// src/components/ui/Input.jsx
import React from "react";

export default function Input({
  type = "text",
  label,
  value,
  onChange,
  placeholder,
  disabled,
  className = "",
  ...props
}) {
  return (
    <div className=" flex-cflexol space-y-1">
      {label && <label className="text-sm text-gray-400">{label}</label>}
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        className={`w-full bg-secondary-800 border border-secondary-700 text-white rounded-lg px-3 py-2 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 ${className}`}
        {...props}
      />
    </div>
  );
}
